export default "__VITE_ASSET__3fb319b5__"